const translations = {
    "app.loading": "Kraunama...",

    "nav.expenses": "Išlaidos",
    "nav.reports": "Išrašai",
    "nav.logout": "Atsijungti",

    "dashboard.title": "Mėnesio ataskaitos",
    "dashboard.description": "Sukurkite mėnesio suvestinę iš vieno ar kelių įkeltų išrašų.",
    "dashboard.create": "Sukurti mėnesio ataskaitą",
    "dashboard.reportsLabel": "Išrašai",
    "dashboard.chooseReports": "Pasirinkite išrašus",
    "dashboard.selectedReports": "Pasirinkta: {count}",
    "dashboard.createButton": "Sukurti",
    "dashboard.creating": "Kuriama...",
    "dashboard.list": "Mėnesio ataskaitos",
    "dashboard.comparison": "Mėnesių palyginimas",
    "dashboard.loading": "Kraunamos mėnesio ataskaitos...",
    "dashboard.noReports": "Pirmiausia įkelkite bent vieną išrašą.",
    "dashboard.empty": "Mėnesio ataskaitų dar nėra.",
    "dashboard.emptyYear": "Pasirinktais metais mėnesio ataskaitų nėra.",
    "dashboard.year": "Metai",
    "dashboard.expense": "Išlaida",
    "dashboard.amount": "Suma",

    "auth.email": "Elektroninis paštas",
    "auth.password": "Slaptažodis",
    "auth.confirmPassword": "Pakartokite slaptažodį",
    "auth.login": "Prisijungti",
    "auth.loginWithGoogle": "Prisijungti su Google",
    "auth.noAccount": "Neturi paskyros? ",
    "auth.signupLink": "Susikurk",
    "auth.signupTitle": "Sukurti paskyrą",
    "auth.signupSubtitle": "Pradėkite sekti savo finansus",
    "auth.signupButton": "Sukurti paskyrą",
    "auth.continueWithGoogle": "Tęsti su Google",
    "auth.hasAccount": "Jau turite paskyrą? ",
    "auth.loginLink": "Prisijungti",

    "expenses.title": "Išlaidos",
    "expenses.description": "Tvarkykite išlaidų kategorijas ir jų atpažinimo žodžius.",
    "expenses.create": "Sukurti išlaidą",
    "expenses.list": "Išlaidų sąrašas",
    "expenses.loading": "Kraunamos išlaidos...",
    "expenses.emptyTitle": "Išlaidų dar nėra",
    "expenses.emptyDescription": "Sukurkite pirmą išlaidų kategoriją, kad galėtumėte atpažinti operacijas.",
    "expenses.table.title": "Pavadinimas",
    "expenses.table.matchers": "Atpažinimo žodžiai",
    "expenses.table.actions": "Veiksmai",
    "expenses.noMatchers": "Atpažinimo žodžių nėra",
    "expenses.edit": "Redaguoti",
    "expenses.delete": "Ištrinti",
    "expenses.deleting": "Trinama...",
    "expenses.save": "Išsaugoti",
    "expenses.saving": "Saugoma...",
    "expenses.cancel": "Atšaukti",
    "expenses.addMatcher": "Pridėti atpažinimo žodį",
    "expenses.removeMatcher": "Pašalinti",
    "expenses.matcherPlaceholder": "Atpažinimo žodis",
    "expenses.titleAria": "Išlaidos pavadinimas",
    "expenses.matcherAria": "Atpažinimo žodis",
    "expenses.confirmDelete": "Ar tikrai norite ištrinti šią išlaidą?",

    "expenses.new.title": "Sukurti išlaidą",
    "expenses.new.description": "Pridėkite išlaidų kategoriją ir pasirinktinius atpažinimo žodžius automatiniam priskyrimui.",
    "expenses.new.details": "Išlaidos informacija",
    "expenses.new.titleLabel": "Išlaidos pavadinimas",
    "expenses.new.titlePlaceholder": "Pavyzdžiui: Maistas",
    "expenses.new.matchers": "Atpažinimo žodžiai",
    "expenses.new.matchersDescription": "Šie žodžiai vėliau gali būti naudojami operacijoms priskirti prie šios išlaidos.",
    "expenses.new.matcherPlaceholder": "Pavyzdžiui: Lidl, Rimi, Maxima",
    "expenses.new.removeMatcher": "Pašalinti",
    "expenses.new.creating": "Kuriama...",

    "reports.title": "Išrašai",
    "reports.description": "Įkelkite CSV failą. Kiekviena failo eilutė bus išsaugota kaip atskira išrašo eilutė.",
    "reports.upload": "Įkelti išrašą",
    "reports.titleLabel": "Išrašo pavadinimas",
    "reports.titlePlaceholder": "Pavyzdžiui: 2026 liepos banko išrašas",
    "reports.fileLabel": "CSV failas",
    "reports.uploadButton": "Įkelti",
    "reports.uploading": "Įkeliama...",
    "reports.list": "Įkelti išrašai",
    "reports.loading": "Kraunami išrašai...",
    "reports.empty": "Išrašų dar nėra.",
    "reports.table.title": "Pavadinimas",
    "reports.table.rows": "Eilučių skaičius",
    "reports.table.assignedRows": "Priskirta",
    "reports.table.status": "Būsena",
    "reports.table.actions": "Veiksmai",
    "reports.processed": "Apdorota",
    "reports.processing": "Apdorojama",
    "reports.view": "Peržiūrėti",
    "reports.delete": "Ištrinti",
    "reports.deleting": "Trinama...",
    "reports.confirmDelete": "Ar tikrai norite ištrinti šį išrašą?",
    "reports.report": "Išrašas",
    "reports.back": "Grįžti",
    "reports.assignmentProgress": "Priskirta {assigned} iš {total} eilučių.",
    "reports.assignExpenses": "Priskirti išlaidas",
    "reports.noExpenses": "Pirmiausia sukurkite bent vieną išlaidų kategoriją.",
    "reports.row": "Eilutė",
    "reports.amount": "Suma",
    "reports.currency": "Valiuta",
    "reports.details": "Detalės",
    "reports.beneficiary": "Gavėjas",
    "reports.expense": "Išlaida",
    "reports.chooseExpense": "Pasirinkite išlaidą",
};

export function t(key, params = {}) {
    const template = translations[key] || key;

    return Object.entries(params).reduce(
        (text, [param, value]) => text.replace(`{${param}}`, value),
        template
    );
}
